import { _mock } from 'src/_mock';
import { useAuthContext } from 'src/auth/hooks/use-auth-context';

export function useMockedUser() {
  const emp = useAuthContext();

  const HOST_API = process.env.REACT_APP_HOST_API;

  if (!emp) {
    return { user: null };
  }

  const userWithMock = {
    id: emp.user.emp.employeeNo,
    lastnameEN: emp.user.emp.lastnameEN,
    firstnameTH: emp.user.emp.firstnameTH,
    firstnameEN: emp.user.emp.firstnameEN,
    displayName: emp.user.emp.fullNameEN,
    positionNameTH: emp.user.emp.positionNameTH,
    positionNameEN: emp.user.emp.positionNameEN,
    birthday: emp.user.emp.birthday,
    email: emp.user.emp.email,
    gender: emp.user.emp.gender,
    supervisorName: emp.user.emp.supervisorName,
    jobGradeName: emp.user.emp.jobGradeName,
    tel: emp.user.emp.mobileNo,
    photoURL: `${HOST_API}/assets/images/employee/${emp.user.emp.employeeNo}.png`,
    jobTitleNameTH: emp.user.emp.jobTitleNameTH,
    jobTitleNameEN: emp.user.emp.jobTitleNameEN,
    employeeGroupName: emp.user.emp.employeeGroupName,
    brandCode: emp.user.emp.brandCode,
    dateJoined: emp.user.emp.dateJoined,
    divisionName: emp.user.emp.divisionName,
    sectionName: emp.user.emp.sectionName,
    subSection1Name: emp.user.emp.subSection1Name,
    subSection2Name: emp.user.emp.subSection2Name,
    departmentName: emp.user.emp.departmentName,
    companyCode: emp.user.emp.companyCode,
    jobGrade: emp.user.emp.jobGrade,
    nickname: emp.user.emp.nickname,
    yos: emp.user.emp.yearOfService,
    companyName: emp.user.emp.companyName,
  };

  return { user: userWithMock };
}
